var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_6583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8736 2.99997H3.12636C1.40204 2.99997 0 4.40201 0 6.12306V23.6239C0 25.345 1.40204 26.747 3.12636 26.747H26.8736C28.5977 26.747 30 25.345 30 23.6239L29.9998 6.12306C29.9998 4.40201 28.5977 2.99997 26.8734 2.99997H26.8736ZM28.7495 23.6238C28.7495 24.6564 27.9096 25.4997 26.8736 25.4997H3.12636C2.09063 25.4997 1.25047 24.6565 1.25047 23.6238V9.2492H28.7494L28.7495 23.6238ZM28.7495 7.99845H1.25058V6.12255C1.25058 5.08992 2.09052 4.24666 3.12647 4.24666H26.8738C27.9095 4.24666 28.7497 5.08987 28.7497 6.12255L28.7495 7.99845Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37492 12.9985H6.87484C7.22001 12.9985 7.49976 12.7188 7.49976 12.3736C7.49976 12.0284 7.22001 11.7487 6.87484 11.7487H4.37492C4.02975 11.7487 3.75 12.0287 3.75 12.3736C3.75 12.7186 4.02975 12.9985 4.37492 12.9985Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37494 17.9988H6.87486C7.22003 17.9988 7.49978 17.7191 7.49978 17.3739C7.5 17.0285 7.22025 16.7487 6.87508 16.7487H4.37517C4.02999 16.7487 3.75024 17.0285 3.75024 17.3737C3.75002 17.7188 4.02977 17.9988 4.37494 17.9988Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7498 12.9985H24.9998C25.3449 12.9985 25.6247 12.7188 25.6247 12.3736C25.6247 12.0284 25.3447 11.7487 24.9998 11.7487H13.7498C13.4046 11.7487 13.1249 12.0287 13.1249 12.3736C13.1249 12.7186 13.4048 12.9985 13.7498 12.9985Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7498 17.9988H24.9998C25.3449 17.9988 25.6247 17.7191 25.6247 17.3739C25.6249 17.0285 25.3449 16.7487 24.9998 16.7487H13.7498C13.4046 16.7487 13.1249 17.0285 13.1249 17.3737C13.1249 17.7188 13.4048 17.9988 13.7498 17.9988Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37492 22.9983H6.87484C7.22001 22.9983 7.49976 22.7186 7.49976 22.3734C7.49976 22.0282 7.22001 21.7485 6.87484 21.7485H4.37492C4.02975 21.7485 3.75 22.0282 3.75 22.3734C3.75 22.7186 4.02975 22.9983 4.37492 22.9983Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7498 22.9983H24.9998C25.3449 22.9983 25.6247 22.7186 25.6247 22.3734C25.6247 22.0282 25.3447 21.7485 24.9998 21.7485H13.7498C13.4046 21.7485 13.1249 22.0282 13.1249 22.3734C13.1249 22.7186 13.4048 22.9983 13.7498 22.9983Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_6583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterface);
export default __webpack_public_path__ + "static/media/interface.ebf7536ee86b07dd26b038876e506873.svg";
export { ForwardRef as ReactComponent };